// Rarity tiers from observation count. Per the PRD: Common >100,
// Uncommon 10–100, Rare <10. Thresholds are isolated here so they're
// trivial to tune after real-world use.

export type RarityTier = "Common" | "Uncommon" | "Rare";

export const RARITY_THRESHOLDS = {
  commonAbove: 100, // count > 100  -> Common
  uncommonAtLeast: 10, // 10 <= count <= 100 -> Uncommon; else Rare
};

export function rarityTier(count: number): RarityTier {
  if (count > RARITY_THRESHOLDS.commonAbove) return "Common";
  if (count >= RARITY_THRESHOLDS.uncommonAtLeast) return "Uncommon";
  return "Rare";
}

// Lowercase rank for the shared <RarityPill>. One adapter so every pill
// (SpeciesCard, SpeciesHero) maps tiers the same way.
export function tierToRank(count: number): "common" | "uncommon" | "rare" {
  const t = rarityTier(count);
  return t === "Common" ? "common" : t === "Rare" ? "rare" : "uncommon";
}

export const RARITY_STYLE: Record<
  RarityTier,
  { label: string; className: string }
> = {
  Common: {
    label: "Common",
    className: "bg-aqua/15 text-aqua ring-1 ring-inset ring-aqua/30",
  },
  Uncommon: {
    label: "Uncommon",
    className: "bg-aqua-deep/15 text-aqua-deep ring-1 ring-inset ring-aqua-deep/30",
  },
  Rare: {
    label: "Rare",
    className: "bg-coral/15 text-coral ring-1 ring-inset ring-coral/40",
  },
};

export const RARITY_ORDER: RarityTier[] = ["Common", "Uncommon", "Rare"];
